import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Modal, Header, Button, Icon } from "semantic-ui-react";

class ErrorModal extends PureComponent {
  static propTypes = {
    className: PropTypes.object,
    onClose: PropTypes.func,
    error: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    copy: PropTypes.object.isRequired
  };

  static defaultProps = {
    open: false
  };

  componentWillUnmout() {
    console.log("componentWillUnmout");
    // this.props.onClose(false);
  }

  // -- HANDLERS -- //

  closeHandler = evt => {
    const { onClose } = this.props;

    if (!onClose) return null;

    // using dataset rather than bind to reduce renders
    const confirmed = evt.target.dataset.confirmed === "true";
    onClose(confirmed);
  };

  // -- RENDER -- //

  render() {
    const { error, className, open, onClose, copy } = this.props;

    const modalProps = {
      className,
      open,
      closeOnDimmerClick: false,
      closeIcon: !!onClose,
      onClose: onClose ? this.closeHandler : null
    };

    return (
      <Modal {...modalProps}>
        <Header icon="exclamation circle" content={error.title || copy.title} />
        <Modal.Content>
          <p>
            <strong>{error.message}</strong>
          </p>
          <p>
            <strong>{copy.status_header}:</strong>
            {` ${error.status} ${error.statusText}`}
          </p>
          {error.url && (
            <p>
              <strong>{copy.url_header}:</strong>
              {error.url}
            </p>
          )}
        </Modal.Content>

        {onClose && (
          <Modal.Actions>
            <Button
              color="green"
              data-confirmed="true"
              onClick={this.closeHandler}
            >
              <Icon name="checkmark" /> {copy.ok}
            </Button>
          </Modal.Actions>
        )}
      </Modal>
    );
  }
}

export default ErrorModal;
